import { a as r } from "../internals/array-to-reversed.js";
import { a as e } from "../internals/array-buffer-view-core.js";
var a = e.aTypedArray,
  t = e.exportTypedArrayMethod,
  o = e.getTypedArrayConstructor;
t("toReversed", function () {
  return r(a(this), o(this));
});